import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { State } from "../../../../domain/model/ResponseState";
import { Order, UpdateOrderModel } from "../../../../domain/model/Order";
import { UpdateOrderUseCase } from "../../../../domain/usecase/order/update/UseCase";
import {
  downloadBlob,
  showGlobalLoadingView,
} from "../../../../core/utils/Utils";
import { GetOrderByIdUseCase } from "../../../../domain/usecase/order/getById/UseCase";
import { DownloadOrderReceiptCase } from "../../../../domain/usecase/order/downloadReceipt/UseCase";

export function OrderDetailsViewModel(
  id: string,
  getOrderByIdUseCase: GetOrderByIdUseCase,
  updateOrderUseCase: UpdateOrderUseCase,
  downloadOrderReceiptCase: DownloadOrderReceiptCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [order, setOrder] = useState<Order>();

  useEffect(() => {
    fetchOrder(id);
  }, []);

  async function fetchOrder(id: string) {
    setLoading(true);
    const response = await getOrderByIdUseCase.invoke(id);
    setLoading(false);
    switch (response.responseState) {
      case State.Success:
        setOrder(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  async function updateOrder(id: string, model: UpdateOrderModel) {
    showGlobalLoadingView(true);
    const response = await updateOrderUseCase.invoke(id, model);
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        showSnackbar(response.data?.message, "success");
        setOrder((prev) =>
          prev ? { ...prev, status: model.status ?? prev.status } : prev
        );
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  async function downloadReceipt(id: string) {
    showGlobalLoadingView(true);
    const response = await downloadOrderReceiptCase.invoke(id);
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        downloadBlob(
          response.data,
          `receipt_${order?.orderId}_${Date.now()}.pdf`
        );
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return {
    isLoading,
    fetchOrder,
    updateOrder,
    order,
    downloadReceipt,
  };
}
